import React, { useEffect, useRef, useState } from "react";
import styles from "./input.module.css";
import ArrowDown from "./ArrowDown";
import ArrowUp from "./ArrowUp";

function Input({ values, placeHolder, header, state, Setstate, error }) {
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  function handleOpen(event) {
    event.preventDefault();
    setOpen(!open);
  }
  function handleClick(value) {
    Setstate(value);
    setOpen(false);
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [inputRef]);

  return (
    <div className={styles.body}>
      <h1 className={styles.h1}>{header}</h1>
      <div className={styles.main}>
        <div ref={inputRef} onClick={(event) => handleOpen(event)}>
          {open ? (
            <div className={styles.all_options}>
              <div className={styles.select_trigger_options}>
                <span>{state ? values[state] : placeHolder}</span>
                <div className={styles.arrow}>
                  <ArrowUp color={"#FA7835"} />
                </div>
              </div>
              <div className={styles.options}>
                {Object.keys(values).map((value) => (
                  <div
                    className={
                      value === state ? styles.list_selected : styles.list
                    }
                    key={value}
                    onClick={() => handleClick(value)}
                  >
                    {values[value]}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div
              className={
                error ? styles.select_trigger_error : styles.select_trigger
              }
            >
              <span>{state ? values[state] : placeHolder}</span>
              <div className={styles.arrow}>
                <ArrowDown color={"#FA7835"} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.error}>{error}</div>
    </div>
  );
}

export default Input;
